import { render, staticRenderFns } from "./c-l.vue?vue&type=template&id=5143b64c"
import script from "./c-l.vue?vue&type=script&lang=js"
export * from "./c-l.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5143b64c')) {
      api.createRecord('5143b64c', component.options)
    } else {
      api.reload('5143b64c', component.options)
    }
    module.hot.accept("./c-l.vue?vue&type=template&id=5143b64c", function () {
      api.rerender('5143b64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/list/c-l.vue"
export default component.exports